import { render, staticRenderFns } from "./NavigationProduct.vue?vue&type=template&id=60a90978&"
import script from "./NavigationProduct.vue?vue&type=script&lang=js&"
export * from "./NavigationProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports